import {useContext} from 'react';
import {Context as RampContext} from '../contexts/RampContext';

export const useRamp = () => useContext(RampContext);
